import { render, staticRenderFns } from "./topRightcomplexTwo.vue?vue&type=template&id=6474bd2c&scoped=true"
import script from "./topRightcomplexTwo.vue?vue&type=script&lang=js"
export * from "./topRightcomplexTwo.vue?vue&type=script&lang=js"
import style0 from "./topRightcomplexTwo.vue?vue&type=style&index=0&id=6474bd2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474bd2c",
  null
  
)

export default component.exports